import React, { useCallback, useState, useEffect, useRef } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";
import { CustomTextField } from '../styles/SharedStyles';

const generateRandomChar = (min, max) =>
  String.fromCharCode(Math.floor(Math.random() * (max - min + 1) + min));

const generateCaptchaText = () => {
  let captcha = "";
  for (let i = 0; i < 6; i++) {
    captcha += generateRandomChar(48, 57); // Numbers
  }
  return captcha.split("").sort(() => Math.random() - 0.5).join("");
};

const CaptchaDialog = ({ open, onClose, onSuccess, title = null, message = null }) => {
  const [captchaText, setCaptchaText] = useState("");
  const [userInput, setUserInput] = useState("");
  const [error, setError] = useState("");
  const canvasRef = useRef(null);

  const initializeCaptcha = useCallback(() => {
    const newCaptcha = generateCaptchaText();
    setCaptchaText(newCaptcha);

    const canvas = canvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext("2d");
      drawCaptchaOnCanvas(ctx, newCaptcha);
    }
  }, []);

  useEffect(() => {
    if (open) {
      setUserInput("");
      setError("");
      setTimeout(() => initializeCaptcha(), 100);
    }
  }, [open, initializeCaptcha]);

  const drawCaptchaOnCanvas = (ctx, captcha) => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    const textColors = ["#edcf91", "#dfa83a"];
    const letterSpace = 150 / captcha.length;
    for (let i = 0; i < captcha.length; i++) {
      const xInitialSpace = 25;
      ctx.font = "24px Roboto Mono";
      ctx.fillStyle = textColors[Math.floor(Math.random() * 2)];
      ctx.fillText(
        captcha[i],
        xInitialSpace + i * letterSpace,
        Math.floor(Math.random() * 16 + 25), // Randomized Y position
        100
      );
    }
  };

  const handleVerify = () => {
    if (userInput === captchaText) {
      onSuccess();
      onClose();
    } else {
      setError("验证码错误，请重试");
      initializeCaptcha(); // Refresh CAPTCHA on failure
      setUserInput("");
    }
  };

  return (
    <Dialog open={open} onClose={onClose}
      sx={{
        '& .MuiPaper-root': {
          backgroundColor: 'var(--bg-secondary-color)',
          color: '#fff',
          maxWidth: '320px',
          width: '80%',
          paddingBottom: 1,      

          '& .MuiDialogContent-root p': {
            fontWeight: '300',
          }
        }
      }}
    >
      <DialogTitle variant="h5">{title ?? "CAPTCHA 验证"}</DialogTitle>
      <DialogContent>
        <Box 
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2
          }}
        >
          {message != null && (
              <Typography variant="body2">{message}</Typography>
          )}

          <canvas ref={canvasRef} width="200" height="60" style={{ border: "2px solid var(--primary-color)", borderRadius: 8, width: '100%' , height: '4rem'}} />

          <CustomTextField
            label="验证码"
            variant="outlined"
            fullWidth
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            error={!!error}
            helperText={error}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" className="outline-button">取消</Button>
        <Button onClick={handleVerify} variant="contained" className="primary-button">确定</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CaptchaDialog;
